<template>
  <div class="content-info">
    <div class="title">
      <p>{{ content && content.title ? content.title : "Loading..." }}</p>
    </div>
    <div class="artist">
      <p>{{ content && content.artist ? content.artist : "" }}</p>
    </div>
    <div class="blank"></div>
    <div class="detail">
      <p>
        {{ content && content.comment ? content.comment : "Loading..." }}
      </p>
    </div>
    <share-button
      :content="content"
      :key="content.side + content.index"
    ></share-button>
  </div>
</template>
<script>
import ShareButton from "./ShareButton.vue";
//TODO 作品の情報とかを保持、templateに反映できるようにする
export default {
  components: { ShareButton },
  name: "ContentInfo",
  props: {
    content: {
      type: Object,
      default: undefined,
    },
  },
};
</script>
<style scoped lang="scss">
.content-info {
  font-family: "Helvetica Neue", "Helvetica", "Hiragino Sans",
    "Hiragino Kaku Gothic ProN", "Arial", "Yu Gothic", "Meiryo", sans-serif;
  flex: 5;
  padding: 2%;
  flex-direction: column;
  text-align: center;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  height: 90%;
  @media (max-width: 1000px) {
    display: inherit;
    flex-basis: 10%;
    flex: 1;
  }
}
.title {
  flex: 2;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  // display: flex;
  flex-direction: column;
  justify-content: center;
  &.nomal {
    word-wrap: break-word;
  }
  @media (max-width: 1000px) {
    p {
      font-size: 28px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    height: 15%;
    flex: 1;
  }
  @media (max-height: 600px) {
    p {
      font-size: 18px;
    }
  }
}

.artist {
  flex: 2;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  // display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1000px) {
    flex: 1;
    height: 15%;
    font-size: 20px;
  }
  @media (max-height: 600px) {
    font-size: 14px;
  }
}

.blank {
  flex: 1;
  width: 100%;
  @media (max-width: 1000px) {
    height: 0%;
  }
}

.detail {
  padding: 0.5em 1em;
  box-sizing: border-box;
  flex: 5;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  //改行を反映する用
  white-space: pre-line;
  text-align: left;
  overflow-y: scroll;
  font-size: 18px;
  display: inline-block;
  line-height: 27px;
  border-radius: 1%;
  background-color: rgb(165, 165, 165);
  max-height: 60vh;
  margin-bottom: 0.5em;

  @media (max-width: 1000px) {
    font-size: 16px;
    flex: 4;
    height: 70%;
    max-height: auto;
  }
  .light & {
    background-color: rgb(179, 179, 179);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  }
  .dark & {
    background-color: rgb(59, 59, 59);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
}
</style>
